import {
  findNodes,
  removeNodesFromTree,
} from '../../../components/Tree/helpers/helpers';
import { selectTreeDataByTreeId, updateData } from '../../selectors/tree/tree';

export const removeTreeControlsOfType =
  (tree, type) => async (dispatch, getState) => {
    const state = getState();
    const currentTreeData = selectTreeDataByTreeId(state, tree);
    const paths = findNodes({
      treeData: currentTreeData,
      searchMethod: (ni) => ni.node.type === type,
    }).matches.map((m) => m.path);
    const { treeData } = removeNodesFromTree({ paths, treeData: currentTreeData });
    return dispatch(updateData(tree, treeData));
  };
